import { Link } from 'react-router-dom';
import { useState } from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function NavMenuContent({
  setMenuOpen
}: {
  setMenuOpen?: (open: boolean) => void;
}) {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="h-4 w-32 animate-pulse bg-muted rounded" />;
  }
  return <>
      {/* Desktop Menu */}
      <div className="hidden md:flex items-center" style={{
      gap: "32px"
    }}>
        {menuItems.map(item => <Link key={item.id} to={item.href || "#"} className="prepayqr-nav-link">
            {item.label}
          </Link>)}
      </div>

      {/* Mobile Menu Items */}
      {setMenuOpen && <div className="flex flex-col gap-6 mt-8 px-2 md:hidden">
          {menuItems.map(item => <Link key={item.id} to={item.href || "#"} className="prepayqr-nav-link" style={{
        fontSize: "16px"
      }} onClick={() => setMenuOpen(false)}>
              {item.label}
            </Link>)}
        </div>}
    </>;
}
export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  return <header id="header" className="sticky top-0 z-50 w-full">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Georgia&display=swap');
        .prepayqr-nav-link {
          color: rgba(42, 45, 43, 0.8);
          font-size: 14px;
          font-weight: 500;
          text-decoration: none;
          transition: color 0.15s;
          white-space: nowrap;
        }
        .prepayqr-nav-link:hover {
          color: #1F3A2E;
        }
      `}</style>

      <div className="w-full flex items-center justify-center" style={{
      backgroundColor: "#1F3A2E",
      minHeight: "32px",
      paddingTop: "8px",
      paddingBottom: "8px"
    }}>
        <span style={{
        color: "#C8985C",
        fontFamily: "ui-sans-serif, system-ui, sans-serif",
        fontSize: "11px",
        fontWeight: 600,
        letterSpacing: "0.09em",
        textAlign: "center"
      }}>
          ✨ PREPAYQR — SPA CASH FLOW. GUARANTEED.
        </span>
      </div>

      <div className="w-full" style={{
      backgroundColor: "#FFFCF7",
      borderBottom: "1px solid rgba(42,45,43,0.08)"
    }}>
        <div className="page-container">
          <nav className="flex items-center justify-between" style={{
          height: "64px",
          fontFamily: "ui-sans-serif, system-ui, sans-serif",
          alignItems: "center"
        }}>
            <Link to="/" className="flex items-center gap-2 flex-shrink-0" style={{
            textDecoration: "none"
          }}>
              <div className="flex items-center justify-center flex-shrink-0" style={{
              width: "32px",
              height: "32px",
              borderRadius: "9999px",
              backgroundColor: "#1F3A2E"
            }}>
                <span style={{
                color: "#C8985C",
                fontFamily: "Georgia, ui-serif, serif",
                fontSize: "16px",
                fontWeight: 700,
                lineHeight: 1
              }}>
                  Q
                </span>
              </div>
              <span style={{
              color: "#1F3A2E",
              fontFamily: "Georgia, ui-serif, serif",
              fontSize: "18px",
              fontWeight: 700,
              letterSpacing: "-0.01em"
            }}>
                PrepayQR
              </span>
            </Link>

            <MenuProvider menu_id="16">
              <NavMenuContent />
            </MenuProvider>

            <div className="hidden md:flex items-center" style={{
            gap: "16px"
          }}>
              <button aria-label="Toggle theme" className="flex items-center justify-center" style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              padding: "4px",
              color: "rgba(31, 58, 46, 0.5)"
            }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="4" />
                  <path d="M12 2v2" />
                  <path d="M12 20v2" />
                  <path d="m4.93 4.93 1.41 1.41" />
                  <path d="m17.66 17.66 1.41 1.41" />
                  <path d="M2 12h2" />
                  <path d="M20 12h2" />
                  <path d="m6.34 17.66-1.41 1.41" />
                  <path d="m19.07 4.93-1.41 1.41" />
                </svg>
              </button>

              <div className="flex items-center" style={{
              backgroundColor: "rgba(31, 58, 46, 0.06)",
              borderRadius: "9999px",
              paddingTop: "4px",
              paddingBottom: "4px",
              paddingLeft: "10px",
              paddingRight: "10px",
              border: "1px solid rgba(31, 58, 46, 0.15)",
              gap: "6px"
            }}>
                <span style={{
                width: "8px",
                height: "8px",
                borderRadius: "9999px",
                backgroundColor: "#22C55E",
                display: "inline-block",
                flexShrink: 0
              }} />
                <span style={{
                color: "#1F3A2E",
                fontFamily: "ui-sans-serif, system-ui, sans-serif",
                fontSize: "13px",
                fontWeight: 500,
                whiteSpace: "nowrap"
              }}>
                  300+ Spas Live
                </span>
              </div>

              <button className="flex items-center justify-center hover:opacity-90 transition-opacity duration-150" style={{
              backgroundColor: "#1F3A2E",
              color: "#FFFFFF",
              fontFamily: "ui-sans-serif, system-ui, sans-serif",
              fontSize: "13px",
              fontWeight: 600,
              letterSpacing: "0.05em",
              borderRadius: "9999px",
              paddingTop: "10px",
              paddingBottom: "10px",
              paddingLeft: "20px",
              paddingRight: "20px",
              border: "none",
              cursor: "pointer",
              whiteSpace: "nowrap",
              boxShadow: "0px 10px 15px -3px oklch(32.2641% -0.038253 160 / 0.2), 0px 4px 6px -4px oklch(32.2641% -0.038253 160 / 0.2)"
            }}>
                START SOFT ENROLLMENT
              </button>
            </div>

            <Sheet open={menuOpen} onOpenChange={setMenuOpen}>
              <SheetTrigger asChild>
                <button className="md:hidden flex items-center justify-center" style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                color: "#1F3A2E",
                padding: "8px"
              }} aria-label="Open menu">
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="3" y1="6" x2="21" y2="6" />
                    <line x1="3" y1="12" x2="21" y2="12" />
                    <line x1="3" y1="18" x2="21" y2="18" />
                  </svg>
                </button>
              </SheetTrigger>
              <SheetContent side="right" style={{
              backgroundColor: "#FFFCF7"
            }}>
                <SheetHeader>
                  <SheetTitle style={{
                  color: "#1F3A2E",
                  fontFamily: "Georgia, ui-serif, serif",
                  fontSize: "18px"
                }}>
                    PrepayQR
                  </SheetTitle>
                </SheetHeader>
                <MenuProvider menu_id="16">
                  <NavMenuContent setMenuOpen={setMenuOpen} />
                </MenuProvider>
                <div className="px-2 mt-4">
                  <button className="w-full flex items-center justify-center hover:opacity-90 transition-opacity duration-150" style={{
                  backgroundColor: "#1F3A2E",
                  color: "#FFFFFF",
                  fontFamily: "ui-sans-serif, system-ui, sans-serif",
                  fontSize: "13px",
                  fontWeight: 600,
                  letterSpacing: "0.05em",
                  borderRadius: "9999px",
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  border: "none",
                  cursor: "pointer"
                }}>
                    START SOFT ENROLLMENT
                  </button>
                </div>
              </SheetContent>
            </Sheet>
          </nav>
        </div>
      </div>
    </header>;
}